define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginSwitchboard",
	"BusinessPlanning/SwitchboardMixin"
], function(declare,ToolbarPluginSwitchboard,SwitchboardMixin) {

return declare([ToolbarPluginSwitchboard, SwitchboardMixin],
	{
	}
);
});